<template>
	<div>
		<v-container px-0 pb-0>
			<v-row justify-space-between>
				<v-col>
					<v-card class="pa-2 mr-2" flat min-height="340px" height="100%">
						<ResponseCode />
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ResponseCode from "@/components/ResponseCode";

export default {
	components: {
		ResponseCode,
	},
	computed: {},
	methods: {},
	mounted() {},
	data: () => ({
		loading: false,
		settings: {},
	}),
};
</script>

<style></style>
